module.exports = __webpack_public_path__ + "img/image 62.d31ea597.png";